import { render } from "./TransactionModal.vue?vue&type=template&id=6e12da37&scoped=true"
import script from "./TransactionModal.vue?vue&type=script&lang=js"
export * from "./TransactionModal.vue?vue&type=script&lang=js"

import "./TransactionModal.vue?vue&type=style&index=0&id=6e12da37&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e12da37"]])

export default __exports__